import React from 'react';
import ImageZoom from 'react-medium-image-zoom';

import ProjectHeader from './ProjectHeader';

import coverImg from '../../imgs/Cooleaf/Thumbnails.png';
// import processImg from '../../imgs/Cooleaf/process.png';
import feature1 from '../../imgs/Cooleaf/Feature-1.png';
import feature2 from '../../imgs/Cooleaf/Feature-2.png';
import feature3 from '../../imgs/Cooleaf/Feature-3.png';
import quoteImg1 from '../../imgs/Cooleaf/HMW.png';

import researchMethodsImg from '../../imgs/Cooleaf/researchMethods.png';
import affinityImg from '../../imgs/Cooleaf/affinity.png';
import personaImg from '../../imgs/Cooleaf/persona.png';
import empathyMapImg from '../../imgs/Cooleaf/empathyMap.png';
import storyboardImg from '../../imgs/Cooleaf/storyboard.jpg';
import concept1Img from '../../imgs/Cooleaf/concept1.png';
import concept2Img from '../../imgs/Cooleaf/concept2.png';
import concept3Img from '../../imgs/Cooleaf/concept3.png';
import interviewShotImg from '../../imgs/Cooleaf/interviewShot.png';
import gridVsCarouselViewImg from '../../imgs/Cooleaf/gridVsCarouselView.png';
import accessibilityPromtpScreensImg from '../../imgs/Cooleaf/accessibilityPromtpScreens.png';
import postRedesignFrameImg from '../../imgs/Cooleaf/postRedesignFrame.png';
import votingLeaderboardScreensImg from '../../imgs/Cooleaf/votingLeaderboardScreens.png';
// import photoAlbumsGif from '../../imgs/Cooleaf/photoAlbums.gif';
// import photoUploadsGif from '../../imgs/Cooleaf/photoUploads.gif';
// import postInteractionGif from '../../imgs/Cooleaf/postInteraction.gif';
import photoAlbumsGif from '../../imgs/Cooleaf/Cooleaf-Photo-Album.gif';
import photoUploadsGif from '../../imgs/Cooleaf/Cooleaf-Photo-Upload.gif';
import postInteractionGif from '../../imgs/Cooleaf/Cooleaf-Vote.gif';
import recommendationsImg from '../../imgs/Cooleaf/recommendations.png';
//nimport expertResultsImg from '../../imgs/Cooleaf/expertResults.png';
// import userResultsImg from '../../imgs/Cooleaf/userResults.png';

const ListInSection = ({ data }) => {
  return (
    <ul className="list-in-section">
      {data.map((item, index) => {
        return (
          <li key={index}>
            <h4>{index + 1}.</h4>
            <p>
              <strong>{item.header}</strong>
            </p>
            <p>{item.content}</p>
          </li>
        );
      })}
    </ul>
  );
};

const Cooleaf = () => (
  <div className="caseBody" id="cooleaf">
    <section className="head">
      <h2>Enhancing Engagement and Accessibility on Cooleaf</h2>
      <p className="caseIntro">Cooleaf</p>
      <img className="img-responsive img-centered" src={coverImg} alt="" />
    </section>
    {/* <ProjectHeader
      projectName="Multimedia and Accessibility on Cooleaf Platform"
      subtitle="Cooleaf"
      bulletPoints={[
        {
          name: 'Discipline',
          content:
            'User Research, Product Design, Interaction Design, Product Thinking'
        },
        {
          name: 'Role',
          content: 'Product Designer + Project Manager'
        },
        {
          name: 'Team',
          content: {
            __html:
              '<a href="https://www.parharyugvir.com" target="_blank">Yugvir Parhar</a>, <a href="https://www.linkedin.com/in/taylorbunge/" target="_blank">Taylor Bunge</a>, <a href="https://www.linkedin.com/in/madeleine-paulsen-82379a144/" target="_blank">Madeleine Paulsen</a>'
          },
          isHTML: true
        },
        {
          name: 'Timeline',
          content: 'Aug - Dec 2021'
        },
        {
          name: 'Tools',
          content: 'Google Doc, Miro, Balsamiq, Figma'
        }
      ]}
      imgSrc={coverImg}
    /> */}
    <section className="mainSec">
      <div className="left">
        <h3 id="overview">Project Overview</h3>
      </div>
      <div className="right">
        <h4>Background</h4>
        <p className="content-p">
          Cooleaf is an online employee engagement platform that empowers
          colleagues to connect, recognize, and reward each other.
        </p>
        <h4>Problem</h4>
        <p className="content-p">
          Cooleaf seeks to make the platform even more engaging to encourage
          users to utilize it more frequently. To achieve this, Cooleaf decided
          to integrate multimedia features, transitioning from a primarily
          text-based platform where users acknowledge each other's achievements
          and help. Additionally, they aspire to create a more inclusive
          platform that caters to a broader spectrum of users, including those
          with varying accessibility needs.
        </p>
        <h4>My Roles</h4>
        <p className="content-p">
          <strong>User Research:</strong> Organized and conducted interviews,
          and analyzed data to identify key insights.
        </p>
        <p className="content-p">
          <strong>Plan and Management:</strong>
          Facilitated design workshops, updating progress regularly, and
          developed interview scripts to guide discussions.
        </p>
        <p className="content-p">
          <strong>Design and Prototype:</strong>
          Designed wireframes, refined through testing and feedback, culminating
          in high-fidelity prototypes that enhanced user engagement and
          accessibility.
        </p>

        <h4>Impacts and Outcomes</h4>
        <p className="content-p">
          ✅ Low severity ratings (average rating of <strong> 1.1 /4.0 </strong>
          ) for Heuristics evaluation, indicating minor usability issues.
        </p>
        <p className="content-p">
          ✅ <strong> 100% </strong> of testing users felt the new features easy
          to use with SEQ averaged 6.4 among tasks.
        </p>
        <p className="content-p">
          ✅ Presented to leadership and design executive for implementation.
        </p>
      </div>
    </section>

    <section className="mainSec">
      <ImageZoom
        image={{
          src: quoteImg1,
          alt: 'quote',
          className: 'img-responsive img-centered'
        }}
      />
    </section>

    <section className="mainSec">
      <div className="left">
        <h3>Design Solutions</h3>
      </div>
      <div className="right">
        {/* <p className="content-p">
          My team developed a prototype that sought to increase engagement on
          Cooleaf’s platform while including accessibility features, through
          research with stakeholders and accessible technology experts.
        </p>
        <p className="content-p">
          We worked through four major stages in our design process to
          ultimately introduce (1) photo albums, (2) interactions with photos,
          (3) enlarged text and buttons and (4) prompts to add ALT text to the
          platform.
        </p>
        <a className="demo-link inline-block" href="#solution">
          Jump to the solution →
        </a> */}

        <section className="mainSec" id="solution">
          <div className="right">
            <p className="content-p">
              We assessed the efficacy of the prototype, identifed usability
              issues, and evaluated the design from an accessibility perspective
              with heuristic evaluation. The results indicated that there were
              no significant issues with the overall application of the
              heuristics, including visibility of system status, match between
              system and the real world, and user control and freedom.
            </p>
            <h4>Figma Prototype</h4>
            <div className="margin-top-bottom-sm">
              <iframe
                style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}
                width="100%"
                height="450"
                src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2FjiDn2qSDEHAr0VOR8DxVHP%2FCooleaf-expert-eval-prototype%3Fpage-id%3D0%253A1%26node-id%3D2%253A683%26viewport%3D259%252C48%252C0.06%26scaling%3Dscale-down%26starting-point-node-id%3D2%253A683"
                allowFullscreen
              />
            </div>
          </div>
        </section>
      </div>
    </section>

    <section className="mainSec flex-initial">
      <div className="left">
        <h4>
          <strong> Feature 1 </strong>{' '}
          <p>Enhance Community with Photo Albums</p>
        </h4>
      </div>
      <div className="right">
        <p className="content-p">
          <p> </p>
          Usability testing revealed that users found it easy to navigate to
          activities and participate in them. The avarage SEQ score was 6.8 out
          7 (7 means very easy). However, users had difficulty discovering the
          &apos;View Album&apos; button. I proposed moving it above the fold so
          users wouldn&apos;t need to scroll to see it. Readability issues were
          identified when text was small or had low contrast. These will be
          addressed by implementing accessibility recommendations.
          <p> </p>
        </p>

        <img
          className="img-responsive img-centered"
          src={feature1}
          alt="Image explains the photo album feature"
        />
        <ImageZoom
          image={{
            src: photoAlbumsGif,
            alt: 'photo album gif',
            className: 'img-responsive img-centered margin-top-bottom-sm'
          }}
        />
      </div>
    </section>
    <section className="mainSec flex-initial">
      <div className="left">
        <h4>
          <strong> Feature 2 </strong> <p>Photo upload & A11y Guide</p>
        </h4>
      </div>
      <div className="right">
        <p className="content-p">
          <p> </p>
          We surveyed among users and received the scores 6 out of 7 as it was
          easy to complete the task. Additionally, while users noticed the
          accessibility guide, they did not understand its purpose and suggested
          providing examples on how to use the &apos;alt-text&apos; field.
          <p> </p>
        </p>
        <img className="img-responsive img-centered" src={feature2} alt="" />
        <ImageZoom
          image={{
            src: photoUploadsGif,
            alt: 'photo upload gif',
            className: 'img-responsive img-centered margin-top-bottom-sm'
          }}
        />
      </div>
    </section>
    <section className="mainSec flex-initial">
      <div className="left">
        <h4>
          <strong> Feature 3 </strong> <p>Vote, Like and Leaderboard</p>
        </h4>
      </div>
      <div className="right">
        <p className="content-p">
          <p> </p>
          This feature received 6.6 out of 7 (7 means easy to use).Users
          expressed a desire to interact with voting and liking features without
          entering the photo album.
          <p> </p>
        </p>
        <img className="img-responsive img-centered" src={feature3} alt="" />

        <ImageZoom
          image={{
            src: postInteractionGif,
            alt: 'post interaction gif',
            className: 'img-responsive img-centered margin-top-bottom-sm'
          }}
        />
      </div>
    </section>

    <section className="mainSec flex-initial">
      <div className="left">
        <h4>Accessibility Recommendations</h4>
      </div>
      <div className="right">
        <p className="content-p">
          The Cooleaf brand colors were not high contrast and failed to meet
          WCAG 2.1 Level AA standards (see the top right screen). Proactively,
          we developed new brand colors that would provide high contrast and
          still work well within their brand identity (see the bottom right
          screen).
        </p>
        <p className="content-p">
          As of today, Cooleaf just rebranded their company website with high
          color contrast.
        </p>
        <ImageZoom
          image={{
            src: recommendationsImg,
            alt: 'recommendations',
            className: 'img-responsive img-centered margin-top-bottom-sm'
          }}
        />
      </div>
    </section>

    {/* <section className="mainSec">
      <div className="full-width-break-out">
        <ImageZoom
          image={{
            src: processImg,
            alt: 'process',
            className: 'img-responsive img-centered'
          }}
        />
      </div>
    </section> */}

    <section className="mainSec flex-initial">
      <div className="left">
        <h3 id="research">Research Methods</h3>
      </div>
      <div className="right">
        <p className="content-p">
          <ImageZoom
            image={{
              src: researchMethodsImg,
              alt: 'research methods',
              className: 'img-responsive img-centered margin-top-bottom-sm'
            }}
          />
        </p>
      </div>
    </section>

    <section className="mainSec">
      <div className="left">
        <h3>Research Summary</h3>
      </div>
      <div className="right">
        <p className="content-p">
          We followed the interpretation, affinity diagram, and walking the wall
          methods in order to find patterns and relationships among the
          qualitative data we collected in this phase of the project.
        </p>
      </div>

      <div className="full-width-break-out">
        <ImageZoom
          image={{
            src: affinityImg,
            alt: 'affinity diagram',
            className: 'img-responsive img-centered'
          }}
        />
      </div>
    </section>

    <section className="mainSec">
      <div className="left">
        <h3>Insights</h3>
      </div>
      <div className="right">
        <p className="content-p">
          <ListInSection
            data={[
              {
                header: 'Focus on web platform',
                content:
                  'From customer summary report, I learned that 90 % of user traffic is on web.'
              },
              {
                header: 'Navigability (accessibility issue)',
                content:
                  'From accessibility audit and cognitive walkthrough, I found that the platform was not compatible with assistive technologies such as screen reader and couldn’t be navigated with keyboard.'
              },
              {
                header:
                  'Understandability of icons and readability of the content',
                content:
                  'From accessibility audit and interviews, I identified problems that it was difficult to understand verbiage and icons. Low contrast was another issue.'
              },
              {
                header: 'Increase in-platform engagement opportunities',
                content:
                  'Upon stakeholders request, I focused on the challenge page, where most interactivity happened. Multimedia features should be accessible to VIPs.'
              }
            ]}
          />
        </p>
      </div>
    </section>

    <section className="mainSec">
      <div className="left">
        <h3>Persona and Empathy Map</h3>
      </div>
      <div className="right">
        <p className="content-p">
          Our User Personas have varying levels of visual impairments. They work
          in mid-sized companies and use Cooleaf to engage with their
          colleagues. They suffer from common pain points of Cooleaf’s
          inaccessibility which leads to frustrations around the platform, and
          their work environments.
        </p>
        <ImageZoom
          image={{
            src: personaImg,
            alt: 'persona',
            className: 'img-responsive img-centered'
          }}
        />
        <ImageZoom
          image={{
            src: empathyMapImg,
            alt: 'emapthy map',
            className: 'img-responsive img-centered'
          }}
        />
      </div>
    </section>

    <section className="mainSec">
      <div className="left">
        <h3>Storyboard</h3>
      </div>
      <div className="right">
        <p className="content-p">
          The storyboard shows a “happy path” for Laura after inclusion of
          accessibility, and accessible multimedia into the platform so she can
          participate in making her workplace a happy one, and redeem some
          coffee rewards that she loves so much along the way!
        </p>
      </div>
      <div className="full-width-break-out">
        <ImageZoom
          image={{
            src: storyboardImg,
            alt: 'storyboard',
            className: 'img-responsive img-centered'
          }}
        />
      </div>
    </section>

    <section className="mainSec">
      <div className="left">
        <h3 id="design">Define & Ideate</h3>
      </div>
      <div className="right">
        <h4>Brainstorming</h4>
        <p className="content-p">
          My team took inspiration from the Disney Creative Strategy for
          Brainstorming and came up with diverse ideas with the design
          requirements in mind. We affinity mapped the design ideas to form
          clusters, using our rational brains to criticize the outlandish ideas
          and identify features that could be translated to realistic solutions.
          We clustered the design ideas into 3 concepts.
        </p>
      </div>
    </section>
    <section className="mainSec">
      <div className="full-width-break-out">
        <ImageZoom
          image={{
            src: concept1Img,
            alt: 'concept 1',
            className: 'img-responsive img-centered'
          }}
        />
      </div>
      <div className="full-width-break-out">
        <ImageZoom
          image={{
            src: concept2Img,
            alt: 'concept 2',
            className: 'img-responsive img-centered'
          }}
        />
      </div>
      <div className="full-width-break-out">
        <ImageZoom
          image={{
            src: concept3Img,
            alt: 'concept 3',
            className: 'img-responsive img-centered'
          }}
        />
      </div>
    </section>

    <section className="mainSec">
      <div className="left" />
      <div className="right">
        <h4>Concept Feedback Sessions</h4>
        <p className="content-p">
          With our concept sketches, made in low-fidelity prototype to mimic
          basic features, we sought out Cooleaf stakeholders and a competitor
          app user to test the concept.
        </p>
        <p className="content-p">
          <strong>Goal: </strong> We organized our feedback questions on three
          main considerations:
          <br />
          1. Feasibility of Cooleaf to implement the idea
          <br />
          2. Appeal of feature to user
          <br />
          3. Comprehension of feature to user
          <br />
        </p>
        <p className="content-p">
          <strong>Results:</strong> The photo concepts appealed most to our
          reviewers as they all ranked this concept as “most satisfied” from the
          interviews. The photos concept added the most engagement. Voting was
          the most popular feature of interest as Cooleaf employees and current
          users both felt the feature directly addressed a specific pain point -
          having to migrate off Cooleaf to engage with the content uploaded
          during activities. The reviewers also felt that the features within
          the first concept were the most feasible for Cooleaf to execute.
        </p>
        <p className="content-p">
          <strong>Next step:</strong> We applied our findings from the design
          concept sessions to inform the wireframe.
        </p>
      </div>
    </section>

    <section className="mainSec">
      <div className="left" />
      <div className="right">
        <h4>Wireframes</h4>
        <p className="content-p">
          The combined feedback from stakeholders helped lead us towards making
          decisions for subsequent wireframes and prototypes.
        </p>
        <p className="content-p">
          We futher developed the Photo ablums concept and broke down the
          concept into 3 different features. Under each feature, we developed
          two formatting options and polled participants’ preference. Below are
          the categories under which we created the wireframes.
        </p>
      </div>
    </section>

    <section className="mainSec">
      <div className="left" />
      <div className="right">
        <h4>Feature 1 Photo Albums</h4>
        <p className="content-p">
          This feature introduces a photo album feature that allows users to
          view all the media associated with an activity in one consolidated
          place. This alleviates the user from having to scroll the entire
          challenge feed to find a particular post.
        </p>
        <p className="content-p">
          This feature is displayed on the side panel of the activities page.
          It’s a consolidated view of thumbnails from each post from an
          activity. The “View Album” button takes the user to a list of all
          media/ posts. We designed the album layout in two ways - “Option A”, a
          wall of posts, and “Option B”, a carousel of each post with thumbnails
          of other posts on the side panel.
        </p>
        <ImageZoom
          image={{
            src: gridVsCarouselViewImg,
            alt: 'grid vs carouse view',
            className: 'img-responsive img-centered'
          }}
        />
      </div>
    </section>

    <section className="mainSec">
      <div className="left" />
      <div className="right">
        <h4>Feature 2 Photo Uploads</h4>
        <p className="content-p">
          Wireframe for uploading images for recognizing colleagues with added
          accessibility guide as two different layouts - popup and static text.
          This feature prompts users to enter alt text when uploading an image
          and helps them learn more about accessibility on the web. Here we
          present the same “pop up” and “static text block” options for the
          accessibility guide for users. These are the screens for uploading
          images while recognizing someone, a heavily performed task on the
          platform.
        </p>
        <ImageZoom
          image={{
            src: accessibilityPromtpScreensImg,
            alt: 'accessibility promtp screens',
            className: 'img-responsive img-centered'
          }}
        />
      </div>
    </section>

    <section className="mainSec">
      <div className="left" />
      <div className="right">
        <h4>Feature 2 Boosting Engagement with Multimedia</h4>
        <p className="content-p">
          For users to be able to vote and interact with the posts, we had to
          redesign the “post” itself. The current version of the post feature
          does not allow for other users to comment on or interact with the post
          apart from “liking” it. Based on concept feedback and findings from
          user interviews, we devised a new post system that would allow users
          to have interaction capabilities for each post, viz., comment, reply
          to comments, have @ mentions, and vote. Once the user votes on a post,
          it changes to indicate that the post has been voted on. The user has
          freedom to undo their vote as well.
        </p>
        <p className="content-p">
          Wireframe for redesigned post to include multiple comments and voting
          feature
        </p>
        <ImageZoom
          image={{
            src: postRedesignFrameImg,
            alt: 'post redesign frame',
            className: 'img-responsive img-centered'
          }}
        />
        <p className="content-p">
          Wireframe for two different layout options for leaderboards - on the
          right panel and under challenge description on center panel
        </p>
        <ImageZoom
          image={{
            src: votingLeaderboardScreensImg,
            alt: 'voiting leaderboard screens',
            className: 'img-responsive img-centered'
          }}
        />
        <h4>Wireframe Feedback Sessions</h4>
        <p className="content-p">
          <strong>Goal:</strong> We wanted to identify features from photo
          concept sketch to include in our initial prototype. During the
          sessions, we focused on which features met the user’s needs and goals
          and which features did not.
        </p>
        <p className="content-p">
          <strong>Results:</strong> We gathered feedback from our users’
          interviews and we recorded their preferences, comments, expectations,
          and suggestions. We found out that the customization ability is highly
          requested among the platform users. We received conflicting feedback
          on the same design and our team came up with the conclusion that we
          should allow some sort of customization on the platform so that users
          can make adjustments according to their needs. People also care about
          accessibility. Our interviewees are happy to see that we are trying to
          improve the platform and make it more accessible. We also identified
          one of the most wanted features, which is the voting feature. We
          definitely will include it in our future design.
        </p>
        <p className="content-p">
          <strong>Next step:</strong> We synthesized our findings and listed
          evidence and design recommendations into the table and it will provide
          insights for the prototype stage.
        </p>
      </div>
    </section>
    <section className="mainSec">
      <div className="full-width-break-out">
        <ImageZoom
          image={{
            src: interviewShotImg,
            alt: 'interview',
            className: 'img-responsive img-centered'
          }}
        />
      </div>
    </section>

    {/* <section className="mainSec flex-initial">
      <div className="left">
        <h3>Evaluation and Usability Testing</h3>
      </div>
      <div className="right">
        <h4>UX Expert Evaluations</h4>
        <p className="content-p">
          <strong>Goal:</strong> Evaluate the efficacy of our prototype, uncover
          any usability issues, and review our design from an accessibility
          standpoint.
        </p>
        <p className="content-p">
          <strong>Process:</strong> We conducted <strong>3</strong> experts
          evaluation with heuristic evaluation with usability and accessibility
          experts. We designed four different tasks for them to complete while
          evaluating the design. Experts were asked to provide a heuristic
          evaluation score and any additional reflections on the interaction and
          prototype.
        </p>
        <ImageZoom
          image={{
            src: expertResultsImg,
            alt: 'expert results',
            className: 'img-responsive img-centered margin-top-bottom-sm'
          }}
        />

        <h4>Usability Testing</h4>
        <p className="content-p">
          <strong>Goal:</strong> Test our design with users and measure the ease
          of use with each interaction point as well as capture user impressions
          using task-based think-aloud testing during the session.
        </p>
        <p className="content-p">
          <strong>Process:</strong> We conducted 5 moderated think-aloud
          usability sessions to solicit feedback on our Cooleaf prototype. 3 of
          them are current Cooleaf users with different experience levels and 2
          of them are competitor platform users. During the sessions, users
          completed the same four scenarios as those outlined in the expert
          evaluation. Participants were encouraged to think aloud and after each
          task, they were also asked to provide an SEQ score (on a scale of 1-7,
          1=Very Difficult).
        </p>
        <ImageZoom
          image={{
            src: userResultsImg,
            alt: 'user results',
            className: 'img-responsive img-centered margin-top-bottom-sm'
          }}
        />

        <h4>Findings</h4>
        <p className="content-p">
          To analyze our qualitative data, we compiled all relevant quotes and
          observations from each expert and user evaluation session. On Miro, we
          grouped these quotes by Issues (Visual, UX Writing, and
          Discoverability issues), Feature Ideas, and Positive Feedback related
          to each task. These groupings helped us flag patterns and common pain
          points to address in our design recommendations.
        </p>
        <ul className="content-list">
          <li>
            Increase color contrast within the platform to improve readability
            and navigability.
          </li>
          <li>
            To increase discoverability, move the “view album” button above the
            fold so that users don’t have to scroll down.
          </li>
          <li>Explain what “alt-text” is and potentially provide examples.</li>
          <li>
            The “Vote” and “Like” functions can be accessed without getting into
            the photo album.
          </li>
        </ul>
      </div>
    </section> */}
  </div>
);

export default Cooleaf;



// WEBPACK FOOTER //
// ./src/Modules/Case/Cooleaf.js